import React, { useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { Modal } from "react-bootstrap";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { PostApi } from "../../api/api-service";
import { API_Path } from "../../Const";
import Select from "react-select";

const problenData = ["Property location is wrong", "Inaccurate property images", "Unauthorized use of images", "Property is not available", "Incorrect pricing property","Copyright Infringement", "Other"];

export default function ReportPropertyModal({ data, onHide }) {
    const [btnLoader, setBtnLoader] = useState(false);
    const setSubmitData = async (formData) => {
        let data = {
            propertyId: data?.data?.uId || "",
            resoan: formData?.resoan || "",
            fullName: formData.fullName,
            email: formData.email,
            message: formData.massage,
        };
        try {
            setBtnLoader(true);
            const res = await PostApi(API_Path.PropertyInquiry, data);
            if (res && res.data.success) {
                toast.success(res.data.message);
                onHide();
            } else toast.error(res.data.message);
            setBtnLoader(false);
        } catch (error) {
            setBtnLoader(false);
        }
    };
    return (
        <Modal size="md" aria-labelledby="contained-modal-title-vcenter" className="modal-details" show={data.flag} centered>
            <Modal.Header className="justify-content-between">
                <Modal.Title>Report this property</Modal.Title>
                <button type="button" onClick={onHide} className="close-icon-style">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                    </svg>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    initialValues={{ resoan: "", fullName: "", email: "", massage: "" }}
                    validationSchema={Yup.object().shape({
                        resoan: Yup.object().required("Resoan is required."),
                        fullName: Yup.string().required("Full name is required."),
                        email: Yup.string().email("Your email address must be in the format of name@domain.com.").required("Email is required."),
                        massage: Yup.string().required("Massage is required."),
                    })}
                    onSubmit={(values, { resetform }) => {
                        setSubmitData(values, resetform);
                    }}
                >
                    {(runform) => (
                        <Form onSubmit={runform.handleSubmit}>
                            <div className="row">
                                <div className="col-12">
                                    <div className="comn-input-main">
                                        <label>
                                            Select a reason <span className="text-danger">*</span>
                                        </label>
                                        <Field name="resoan">
                                            {({ field, form }) => {
                                                const selectedValue = runform.values.resoan ?? "";
                                                return (
                                                    <Select
                                                        {...field}
                                                        // classNamePrefix="custom-select"
                                                        options={problenData.map((type) => ({ value: type, label: type }))}
                                                        onChange={(selectedOption) => form.setFieldValue("resoan", selectedOption)}
                                                        value={selectedValue}
                                                        placeholder="Select a reason"
                                                         classNamePrefix={`custom-select ${runform.errors.fullName && runform.touched.fullName ? "error-bdr" : ""}`} 
                                                    />
                                                );
                                            }}
                                        </Field>
                                        <ErrorMessage name="resoan" component="span" className="error-message" />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="comn-input-main">
                                        <label>
                                            Full Name <span className="text-danger">*</span>
                                        </label>
                                        <Field type="text" placeholder="Enter full name" name="fullName"  className={`form-control ${runform.errors.fullName && runform.touched.fullName ? "error-bdr" : ""}`}  />
                                        <ErrorMessage name="fullName" component="span" className="error-message" />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="comn-input-main">
                                        <label>
                                            Email <span className="text-danger">*</span>
                                        </label>
                                        <Field type="email" placeholder="Enter email" name="email"  className={`form-control ${runform.errors.email && runform.touched.email ? "error-bdr" : ""}`}  />
                                        <ErrorMessage name="email" component="span" className="error-message" />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="comn-input-main">
                                        <label>
                                            Massage <span className="text-danger">*</span>
                                        </label>
                                        <Field as="textarea" placeholder="Enter Massage" rows={4} name="massage"  className={`form-control ${runform.errors.massage && runform.touched.massage ? "error-bdr" : ""}`}  />
                                        <ErrorMessage name="massage" component="span" className="error-message" />
                                    </div>
                                </div>
                                <div className="send-btn">
                                    <button type="submit" className="button" disabled={btnLoader}>
                                        SEND REPORT
                                    </button>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
}
